export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ11.241a7707.mp3";